import Image from 'app/Components/Shared/Image/image';
import React from "react"

const familyIcon = () =>{
    
    return <Image src={require("./family_icon.svg")} alt="family_icon" />

}


export default familyIcon;